var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M20.1 10.2H3.9M15.6 3v3.6M8.4 3v3.6M8.22 21h7.56c1.513 0 2.269 0 2.846-.294a2.7 2.7 0 0 0 1.18-1.18c.294-.578.294-1.334.294-2.846V9.12c0-1.512 0-2.268-.294-2.846a2.7 2.7 0 0 0-1.18-1.18C18.05 4.8 17.292 4.8 15.78 4.8H8.22c-1.512 0-2.268 0-2.845.294a2.7 2.7 0 0 0-1.18 1.18C3.9 6.852 3.9 7.608 3.9 9.12v7.56c0 1.512 0 2.268.295 2.846a2.7 2.7 0 0 0 1.18 1.18C5.952 21 6.708 21 8.22 21"
  })));
};
export default SvgCalendar;